'use strict';

module.exports = /(^|_)([^_]+)/g;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/string/var/CAMELIZE_REG.js
// module id = 593
// module chunks = 1